import { render, staticRenderFns } from "./dlgWrap.vue?vue&type=template&id=73d03edc&scoped=true&"
import script from "./dlgWrap.vue?vue&type=script&lang=js&"
export * from "./dlgWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d03edc",
  null
  
)

export default component.exports